/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExperienceField
 */
export interface ExperienceField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof ExperienceField
     */
    value: ExperienceFieldValueEnum;
}


/**
 * @export
 */
export const ExperienceFieldValueEnum = {
    Entry: 'ENTRY',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT',
    ExpertPlus: 'EXPERT_PLUS'
} as const;
export type ExperienceFieldValueEnum = typeof ExperienceFieldValueEnum[keyof typeof ExperienceFieldValueEnum];


/**
 * Check if a given object implements the ExperienceField interface.
 */
export function instanceOfExperienceField(value: object): value is ExperienceField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ExperienceFieldFromJSON(json: any): ExperienceField {
    return ExperienceFieldFromJSONTyped(json, false);
}

export function ExperienceFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function ExperienceFieldToJSON(value?: ExperienceField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

